import * as angular from 'angular';
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import CheckListsServiceName, {CheckListsService} from "../../services/checkLists/checkLists.service";
import KPIChecksHubServiceName, {KPIChecksHubService} from "../../services/checkLists/kpiChecks.hub";
import {apsEvents} from "../../shared/dto/aps.events";

let requires = [CheckListsServiceName, KPIChecksHubServiceName];

interface CheckListKPIController {
  plantId: string;
  shopId: string;
  wellKnownCheck: apsEnums.WellKnownCheckType;
  loading: boolean;
  kpiCheckResults: apsViewModels.CheckInstanceResultItem;
}

class CheckListKPICtrl implements CheckListKPIController {
  checkListsService: CheckListsService;
  plantId: string;
  shopId: string;
  wellKnownCheck: apsEnums.WellKnownCheckType;
  loading: boolean;
  kpiCheckResults: apsViewModels.CheckInstanceResultItem;
  kpiChecksHub: any;

  constructor(checkListsService: CheckListsService,
              kpiChecksHubService: KPIChecksHubService,
              $timeout: angular.ITimeoutService,
              $scope: angular.IScope) {
    this.checkListsService = checkListsService;
    this.loading = true;

    let updateResult = (update: apsEvents.WellKnownCheckUpdated) => {
      $timeout(() => {
        this.kpiCheckResults.result = update.result;
        this.kpiCheckResults.status = update.status;
        this.kpiCheckResults.checkName = update.checkName;
      });
    };

    $timeout(() => {
      this.checkListsService.getLastValue(
        this.plantId,
        this.shopId,
        this.wellKnownCheck)
        .then((result) => {
          this.kpiCheckResults = result;
          this.loading = false;

          if (result) {
            this.kpiChecksHub = kpiChecksHubService.createKPIChecksHub(updateResult,
              this.shopId, result.wellKnownCheckId);
          }
        });
    });

    $scope.$on('$destroy', () => {
      if (this.kpiChecksHub) {
        this.kpiChecksHub.deregisterListeners();
        this.kpiChecksHub.leaveGroup(this.shopId, this.kpiCheckResults.wellKnownCheckId);
      }
    });
  }
}

export default angular.module('aps.controller.checkListKPI', requires)
  .controller('CheckListKPICtrl', CheckListKPICtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/checkLists/checkListKPI.controller.ts